angular.module('umUser', [])
    .config(function ($stateProvider) {

        $stateProvider
            .state('userList', {
                url: '/user/list/:userType',
                views: {
                    'header': {
                        templateUrl: '/common/header/appHeader.tpl.html',
                        controller: 'appHeaderController'
                    },
                    'content': {
                        templateUrl: '/ui/user/list/userList.tpl.html',
                        controller: 'userListController'
                    }
                }
            })
            .state('userGroups', {
                url: '/userGroups/browser',
                views: {
                    'header': {
                        templateUrl: '/common/header/appHeader.tpl.html',
                        controller: 'appHeaderController'
                    },
                    'content': {
                        templateUrl: '/ui/userGroupsBrowser/userGroupsBrowser.tpl.html',
                        controller: 'userGroupsBrowserController'
                    }
                }
            })
            .state('userGroupEditor', {
                url: '/userGroupEditor/:userGroupId',
                views: {
                    'header': {
                        templateUrl: '/common/header/appHeader.tpl.html',
                        controller: 'appHeaderController'
                    },
                    'content': {
                        templateUrl: '/ui/userGroupEditor/userGroupEditor.tpl.html',
                        controller: 'userGroupEditorController'
                    }
                }
            })
            .state('manageUser', {
                url: '/user/manage/:userType/:userId',
                views: {
                    'header': {
                        templateUrl: '/common/header/appHeader.tpl.html',
                        controller: 'appHeaderController'
                    },
                    'content': {
                        templateUrl: '/ui/user/manage/manageUser.tpl.html',
                        controller: 'manageUserController'
                    }
                }
            })
            .state('manageUser.form', {
                url: '/form/:formId',
                views: {
                    'mainContent': {
                        templateUrl: '/ui/user/manage/formViewer/manageUserFormViewer.tpl.html',
                        controller: 'manageUserFormViewerController'
                    }
                },
                params: {
                    formId: {squash: true, value: null}
                }
            })
            .state('manageUser.formSummaryGridDetail', {
                url: '/form/:formId/detail/:ownerUriId/:formSummaryInstanceId',
                views: {
                    'mainContent': {
                        templateUrl: '/formViewer/component/formSummary/detail/formSummaryGridDetail.tpl.html',
                        controller: 'formSummaryGridDetailController'
                    }
                },
                resolve: {
                    effectiveDate: function () {
                        return {
                            get: function () {
                                return null;
                            }
                        };
                    },
                    currencyCode: function () {
                        return {
                            get: function () {
                                return null;
                            }
                        };
                    },
                    printable: function () {
                        return {
                            get: function () {
                                return false;
                            }
                        }
                    }
                }
            });
    });
